// import { isMobile } from '@/lib/device'
export default [
  {
    path: 'team/management',
    name: 'TeamIndex',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/team/Index`)
  }
  // {
  //   path: 'team/invite/open',
  //   name: 'InviteOpen',
  //   component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/team/InviteJoin`)
  // },
  // {
  //   path: 'team/invite/noregister',
  //   name: 'InviteOpenNoregister',
  //   component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/team/InviteJoinNoRegister`)
  // },
  // {
  //   path: 'team/invite/register',
  //   name: 'InviteOpenRegister',
  //   component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/team/InviteJoinRegister`)
  // }
]
